"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignExportResponseSchema = exports.CampaignExportQuerySchema = exports.CampaignExportSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
const ruby_1 = require("../../../ruby");
exports.CampaignExportSchema = (0, core_1.StrictObject)({
    team: (0, core_1.StrictObject)({
        id: core_1.IdSchema,
        status: ruby_1.TeamStatusSchema,
        inactiveAt: typebox_1.Type.Optional(core_1.TimestampSchema),
    }),
    tier: (0, core_1.StrictObject)({
        id: core_1.IdSchema,
    }),
    campaigns: typebox_1.Type.Array((0, core_1.StrictObject)({
        id: core_1.IdSchema,
        channelType: ruby_1.ChannelTypeSchema,
        status: ruby_1.CampaignStatusSchema,
        inactiveAt: typebox_1.Type.Optional(core_1.TimestampSchema),
    })),
});
exports.CampaignExportQuerySchema = (0, core_1.StrictObject)({
    teamId: typebox_1.Type.Optional(typebox_1.Type.Array(core_1.IdSchema)),
    teamStatus: typebox_1.Type.Array(ruby_1.TeamStatusSchema),
    campaignStatus: typebox_1.Type.Array(ruby_1.CampaignStatusSchema),
});
exports.CampaignExportResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.CampaignExportSchema);
